import { Headline6 } from '@nexus/lib-react/dist/core/Typography/Heading';
import styled from '../../../../../theme/styled';
import DetailsStyle from './DetailsCard';
import { mq } from '../../../../../commons/styles';

export const Card = styled(DetailsStyle.Card)`
  margin-top: 10px;

  ${mq.desktop} {
    margin: 16px;
  }
`;

export const Wrapper = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  background: ${({ theme }) => theme.colors.bgError};
  padding: 16px;
  display: flex;
  flex-flow: column;
  align-items: center;
`;

export const Title = styled(Headline6)`
  text-transform: uppercase;
  margin-bottom: 8px;
`;

export default { Card, Wrapper, Title };
